module.exports = __webpack_public_path__ + "prod/20260929161836/img/service.f8729c23.png";